import CustomBreadcrumb from 'components/CustomBreadcrumb'
import StyledPercentage from 'components/StyledPercentage'
import DetailedForm from 'pages/ClientDetails/DetailedForm'
import {
  StyledContainer,
  StyledImg,
  StyledItem,
  StyledItemsContainer,
  StyledLabel,
  StyledLeftContainer,
  StyledRightContainer,
} from './GeneralTabContent.styles'
import { GeneralTabContentProps } from './GeneralTabContent.types'

const GeneralTabContent = ({
  displayDetailForm,
  handleDetailedFormClose,
  items,
  progressData,
  breadcrumbItems,
  handleBreadcrumbTabChange,
  handleItemClick,
  detailedFormName,
}: GeneralTabContentProps) => {
  return (
    <StyledContainer>
      <CustomBreadcrumb breadcrumbItems={breadcrumbItems} handleBreadcrumbTabChange={handleBreadcrumbTabChange} />
      {displayDetailForm ? (
        <DetailedForm handleItemClick={handleItemClick} handleDetailedFormClose={handleDetailedFormClose} detailedFormName={detailedFormName} />
      ) : (
        <StyledItemsContainer>
          {items.map((item: any) => (
            <StyledItem key={item.label} onClick={handleItemClick.bind(this, item)}>
              <StyledLeftContainer>
                <StyledImg src={item.icon} />
                <StyledLabel>{item.label}</StyledLabel>
              </StyledLeftContainer>
              <StyledRightContainer>
                <StyledPercentage percentage={progressData[item.itemName]} />
              </StyledRightContainer>
            </StyledItem>
          ))}
        </StyledItemsContainer>
      )}
    </StyledContainer>
  )
}

export default GeneralTabContent
